/**
 *  A store for handling the application states. Non persisting store.
 */
const state = {
  /**
   * The application initial state
   */
  isInitializing: false,
  isInitialized: false,
  /**
   * Loading a specific project
   */
  isProjectLoading: false,
  isProjectLoaded: false,
  /**
   * Creating a specific project
   */
  isProjectCreating: false,
  isProjectCreated: false,
  /**
   * Duplicating a project
   */
  isProjectDuplicating: false,
  /**
   * Which template is being created
   */
  templateCreating: null,
  /**
   * Whether to highlight the selections on the board
   */
  showSelections: true,
  exportProgress: null,
};

const getters = {
  /**
   * Returns whether the application is initializing
   * @returns {Boolean}
   */
  getIsInitializing(state) {
    return state.isInitializing;
  },

  /**
   * Returns whether the application has initialized
   * @returns {Boolean}
   */
  getIsInitialized(state) {
    return state.isInitialized;
  },

  /**
   * Returns whether a project is being loaded
   * @returns {Boolean}
   */
  getIsProjectLoading(state) {
    return state.isProjectLoading;
  },

  /**
   * Returns whether the project has finished loading
   * @returns {Boolean}
   */
  getIsProjectLoaded(state) {
    return state.isProjectLoaded;
  },

  /**
   * Returns whether a project is being created
   * @returns {Boolean}
   */
  getIsProjectCreating(state) {
    return state.isProjectCreating;
  },

  /**
   * Returns whether a project has been created
   * @returns {Boolean}
   */
  getIsProjectCreated(state) {
    return state.isProjectCreated;
  },

  /**
   * Returns the template name of the project currently being created
   * @returns {String}
   */
  getTemplateCreating(state) {
    return state.templateCreating;
  },

  /**
   * Returns whether a project is being duplicated
   * @returns {Boolean}
   */
  getIsProjectDuplicating(state) {
    return state.isProjectDuplicating;
  },

  /**
   * Returns whether to hoghlight the selections
   * @returns {Boolean}
   */
  getShowSelections(state) {
    return state.showSelections;
  },

  getExportProgress(state) {
    return state.exportProgress;
  },
};

const mutations = {
  /**
   * Sets whether the application has been initialized
   * @param {Boolean} value
   */
  setIsInitializing(state, { value }) {
    state.isInitializing = value;
    state.isInitialized = !value;
  },

  /**
   * Sets whether we are loading a project
   * @param {Boolean} value
   */
  setIsProjectLoading(state, { value }) {
    state.isProjectLoading = value;
    state.isProjectLoaded = !value;
  },

  /**
   * Sets whether we are creating a project
   * @param {Boolean} value
   */
  setIsProjectCreating(state, { value, template }) {
    state.isProjectCreating = value;
    state.isProjectCreated = !value;
    state.templateCreating = template;
  },

  /**
   * Set whether we are duplicating a project
   * @param {Boolan} value
   */
  setIsProjectDuplicating(state, { value }) {
    state.isProjectDuplicating = value;
  },

  /**
   * Set whether we are showing the selections
   */
  setShowSelections(state, { value }) {
    state.showSelections = value;
  },

  setExportProgress(state, { value }) {
    state.exportProgress = value;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions: {},
  mutations,
};

export default module;
